<template>
    <div>
      <div v-if="excludeTerms.length">
        {{ `${excludeTerms.length || 0} words excluded` }}
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        {{ `${excludeTerms.length || 0} words excluded` }}
      </div>
    </div>
</template>

<script>
import {
  STEPS,
} from "@/components/FullPageSourceEditorV2/components/AiWriter/constants.js";

export default {
    name: 'ConfigPreviewExcludeTerms',
    props: [
        'excludeTerms',
    ],
    computed: {
        STEPS() {
          return STEPS
        },
    }
}
</script>

<style lang="scss" scoped>

</style>